import { Injectable } from '@angular/core';
import { FeatureGroup, Marker } from 'leaflet';

@Injectable({ providedIn: 'root', })
export class UserLayerService {
  readonly userLayer = new FeatureGroup;

  setUserMarker(marker: Marker<any> | undefined) {
    if (marker)
      this.userLayer.addLayer(marker);
    else
      this.userLayer.clearLayers();
  }
}
